module.exports = __webpack_public_path__ + "img/frame (79).46463213.jpg";